import { render, staticRenderFns } from "./URSBRegistry.vue?vue&type=template&id=636da2c2&scoped=true&"
import script from "./URSBRegistry.vue?vue&type=script&lang=js&"
export * from "./URSBRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636da2c2",
  null
  
)

export default component.exports